import { api } from "@/builders/axios";
import { activate_or_deactivate } from "./activate-or-deactivate";
import { domain_names } from "./domain-names";

const put = function (
  link: string,
  data: Partial<{
    name: string;
    unique_link: string;
    location: string;
    email: string;
    phone: string;
    website: string;
    logo: string;
    industry: string;
    size: number;
  }>
) {
  return api.put(`/organizations/${link}`, data);
};

const del = function (link: string) {
  return api.delete(`/organizations/${link}`);
};

export const link = {
  put,
  del,
  domain_names,
  activate_or_deactivate,
};
